module.exports = __webpack_public_path__ + "img/suma-verde.48f5b0ee.png";